import type { Testimonial } from '../types'

export const testimonials: Testimonial[] = [
  {
    id: 'maria',
    name: 'Maria G.',
    location: { en: 'Spring Branch, Houston', es: 'Spring Branch, Houston' },
    quote: {
      en: 'Best cleaning service in Houston! Highly professional from the first phone call to the final walkthrough.',
      es: '¡El mejor servicio de limpieza en Houston! Muy profesionales desde la primera llamada hasta la revisión final.',
    },
    rating: 5,
    initials: 'MG',
  },
  {
    id: 'john',
    name: 'John P.',
    location: { en: 'Katy, TX', es: 'Katy, TX' },
    quote: {
      en: 'They deep cleaned my entire house and it looks amazing — the kitchen honestly looks brand new.',
      es: 'Hicieron limpieza profunda de toda mi casa y quedó increíble; la cocina parece nueva.',
    },
    rating: 5,
    initials: 'JP',
  },
  {
    id: 'sarah',
    name: 'Sarah M.',
    location: { en: 'The Heights, Houston', es: 'The Heights, Houston' },
    quote: {
      en: 'Very professional team with great attention to detail. They caught things I would have never thought to ask for.',
      es: 'Equipo muy profesional y con gran atención al detalle. Notaron cosas que yo nunca habría pedido.',
    },
    rating: 5,
    initials: 'SM',
  },
  {
    id: 'david',
    name: 'David L.',
    location: { en: 'Sugar Land, TX', es: 'Sugar Land, TX' },
    quote: {
      en: 'Amazing service and easy scheduling. Booked a move-out clean same week and got my full deposit back.',
      es: 'Servicio excelente y fácil de agendar. Reservé limpieza de mudanza la misma semana y recuperé todo mi depósito.',
    },
    rating: 5,
    initials: 'DL',
  },
  {
    id: 'angela',
    name: 'Angela R.',
    location: { en: 'Pearland, TX', es: 'Pearland, TX' },
    quote: {
      en: 'Super friendly and thorough. They use safe products, which matters a lot with my kids and dog at home.',
      es: 'Muy amables y detallistas. Usan productos seguros, algo muy importante con mis niños y mi perro en casa.',
    },
    rating: 5,
    initials: 'AR',
  },
]
